<template>
  <div id="settings">
    <QuestionSets />
    <Branding />
    <ContactTypes />
    <Integration />
    <DataManagement />
  </div>
</template>

<script>
/* eslint-disable */
import QuestionSets from '@/views/settings/components/QuestionSets';
import Branding from '@/views/settings/components/Branding';
import ContactTypes from '@/views/settings/components/ContactTypes';
import DataManagement from '@/views/settings/components/DataManagement';
import Integration from '@/views/settings/components/Integration.ts'

export default {
  data () {
    return {
      isMounted: false
    };
  },
  computed: { },
  methods: { },
  mounted () {
    this.isMounted = true;
  },
  components: {
    QuestionSets,
    Branding,
    ContactTypes,
    DataManagement,
    Integration
  }
};
</script>

<style lang="scss">
hr{
    border:none;
    border-bottom:1px solid #eee;
}
    .con-img-upload {
        margin:3px 0 !important;
        padding:0;
        .img-upload{
            height: 8rem;
            width: 100%;
            margin:0 !important;
            img{
                object-fit: contain;
                width: 100%;
            }
        }
        .con-input-upload {
            height: 8rem;
            width: 100%;
            border-radius: 5px !important;
            margin:0 !important;
        }

        .img-upload {
            // height: 4rem;
            margin: 0;
            margin-bottom: .5rem;
            margin-right: 1.5rem;
        }
    }
</style>